import { notification } from "antd";
export const MessageUtil = (type, title, msg) => {

    notification[type]({
        message: title,
        description: msg,
        //placement: 'bottomRight' // posisiones
    });
}